import React from 'react';
import { hydrateRoot, createRoot } from 'react-dom/client';
import './index.scss';
import App from './App';
import { HelmetProvider } from 'react-helmet-async';

const root = document.getElementById('root') as HTMLElement;

const app = (
  <HelmetProvider>
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </HelmetProvider>
);

if (root.hasChildNodes()) {
  hydrateRoot(root, app);  // react-snap pre-rendered HTML exists
} else {
  createRoot(root).render(app);  // normal CRA fallback
}